import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'simpleTaskDeadlineNotification';

const simpleTaskDeadLineNotificationService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  rowData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default simpleTaskDeadLineNotificationService;
